import { render, staticRenderFns } from "./ModelReward.vue?vue&type=template&id=9851223c&scoped=true&"
import script from "./ModelReward.vue?vue&type=script&lang=js&"
export * from "./ModelReward.vue?vue&type=script&lang=js&"
import style0 from "./ModelReward.vue?vue&type=style&index=0&id=9851223c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9851223c",
  null
  
)

export default component.exports